import useDeviceModeFlg from "../../common/useDeviceModeFlg";
import Spinner from "../../common/Spinner";

interface BOP010W010TemplateProps {
  id: string;
  password: string;
  isLoading: boolean;
  onIdChange: (value: string) => void;
  onPasswordChange: (value: string) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
}

const BOP010W010Template = ({
  id,
  password,
  isLoading,
  onIdChange,
  onPasswordChange,
  onSubmit,
}: BOP010W010TemplateProps) => {
  const deviceModeFlg = useDeviceModeFlg();

  return (
    <div
      className={`bop010w010-container ${
        deviceModeFlg ? "deviceMode-sp" : "deviceMode-pc"
      }`}
    >
      <div className="bop010w010-box">
        {isLoading && (
          <div className="bop010w010-loading-overlay">
            <Spinner label="ログイン中..." />
          </div>
        )}
        <div className="icon">家計簿</div>
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label>ID</label>
            <input
              className="bop010w010-input"
              type="text"
              placeholder="ID"
              value={id}
              onChange={(e) => onIdChange(e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>PASSWORD</label>
            <input
              className="bop010w010-input"
              type="password"
              placeholder="パスワード"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
            />
          </div>

          <button
            className="bop010w010-button"
            type="submit"
            disabled={isLoading}
          >
            ログイン
          </button>
        </form>
      </div>
    </div>
  );
};

export default BOP010W010Template;
